module.exports = __webpack_public_path__ + "static/media/asset-listing.94b0987c.svg";